/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import IVno = Models.IVno;

    export interface IAdminVnoModalScope extends ng.IScope {
        title: string;
        vno: IVno;
        users: Models.IUser[];

        owner: {
            user: Models.IUser;
        };

        existing: {
            user: string;
        };

        confirmed: {
            password: string;
        };

        userOptions: EurovisionControl.IRadioOption[];
        adminOption: {
            selected: EurovisionControl.IRadioOption;
        };
        isExistingUserSelected: () => boolean;
        modalClose: () => void;
        modalSave: () => void;
        removeUsernameErrors: () => void;
        removeEmailErrors: () => void;
        passwordHidden: boolean;
        confirmPasswordHidden: boolean;
        togglePasswordVisibility: () => void;
        toggleConfirmPasswordVisibility: () => void;
    }

    export interface IAdminVnoModalResponse {
        name: string;
        existingUser?: Models.User;
        adminName?: string;
        adminEmail?: string;
        adminUsername?: string;
        adminPassword?: string;
    }

    export class AdminVnoModalController {
        public static templateUrl: string = "decorators/modals/admin-vno-modal.html";
        public static id: string = "#admin-vno-modal";
        public static $name: string = "adminVnoModalController";
        public static $inject: string[] = ['$scope', 'close', '$timeout', 'userService', 'title', 'vno', 'users'];

        private $scope: IAdminVnoModalScope;
        private close: (parameters: IAdminVnoModalResponse) => void;
        private watchers: Function[] = [];

        constructor($scope: IAdminVnoModalScope,
                    close: (parameters: IAdminVnoModalResponse) => void,
                    $timeout: ng.ITimeoutService,
                    private userService: Services.UserService,
                    title: string,
                    vno: IVno,
                    users: Models.IUser[]) {
            $timeout(() => {
                window.altair_admin_common_init();
                window.altair_forms_validation();
            }, 500);
            this.$scope = $scope;
            [this.$scope.title, this.$scope.vno, this.$scope.users] = [title, vno, users];
            this.close = close;
            this.init();

            this.watchers.push(
                this.$scope.$watch('adminOption.selected.value', (newVal: string, oldVal: string) => {
                        if (oldVal !== undefined && newVal !== oldVal) {
                            this.$scope.owner = {
                                user: new Models.User(),
                            };
                        }
                    }
                )
            );

            this.$scope.isExistingUserSelected = (): boolean => {
                return this.$scope.adminOption.selected.value === 'Existing user';
            };

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = (): void => {
                if (this.$scope.vno.id === undefined) {
                    this.createVno();
                } else {
                    this.saveVno();
                }
            };

            this.$scope.removeUsernameErrors = (): void => {
                $('[name="username"]').parsley().removeError('error-unique');
            };

            this.$scope.removeEmailErrors = (): void => {
                $('[name="email"]').parsley().removeError('error-unique');
            };

            this.$scope.passwordHidden = true;

            this.$scope.togglePasswordVisibility = (): void => {
                this.$scope.passwordHidden = !this.$scope.passwordHidden;
            };

            this.$scope.confirmPasswordHidden = true;

            this.$scope.toggleConfirmPasswordVisibility = (): void => {
                this.$scope.confirmPasswordHidden = !this.$scope.confirmPasswordHidden;
            };

        }

        private init(): void {
            this.$scope.$on('$destroy', () => {
                this.watchers.forEach((w: Function) => w());
            });
            this.$scope.owner = {
                user: new Models.User(),
            };
            this.$scope.userOptions = [
                {
                    value: 'New user',
                    selected: true,
                }, {
                    value: 'Existing user',
                    selected: false,
                }];
            this.$scope.adminOption = {
                selected: this.$scope.userOptions[0],
            };
            this.$scope.confirmed = {
                password: '',
            };
            this.$scope.existing = {
                user: '',
            };
        }

        private createVno(): void {
            if (this.$scope.vno.name && this.$scope.vno.name !== '') {
                if (this.$scope.adminOption.selected.value === 'New user') {
                    this.createVnoWithNewAdminUser();
                } else {
                    this.createVnoWithExistingAdminUser();
                }
            }
        }

        private saveVno(): void {
            this.close({
                name: this.$scope.vno.name,
            });
        }

        private createVnoWithNewAdminUser(): void {
            if (this.$scope.owner.user !== undefined &&
                this.$scope.owner.user.fullname !== undefined && this.$scope.owner.user.fullname !== '' &&
                this.$scope.owner.user.username !== undefined && this.$scope.owner.user.username !== '' &&
                this.$scope.owner.user.email !== undefined && this.$scope.owner.user.email !== '' &&
                this.$scope.owner.user.password !== undefined && this.$scope.owner.user.password !== '' &&
                this.$scope.confirmed.password !== undefined && this.$scope.confirmed.password !== '' ) {

                if (this.$scope.owner.user.password === this.$scope.confirmed.password) {
                    this.validateUniques().then( () => {
                        this.close(
                            {
                                name: this.$scope.vno.name,
                                adminName: this.$scope.owner.user.fullname,
                                adminEmail: this.$scope.owner.user.email,
                                adminUsername: this.$scope.owner.user.username,
                                adminPassword: this.$scope.owner.user.password,
                            }
                        );
                    }).catch(() => {
                        // avoid error
                    });
                }

            }
        }

        private createVnoWithExistingAdminUser(): void {
            if (this.$scope.existing.user) {
                this.$scope.users
                    .filter((user: Models.IUser) => user.fullname === this.$scope.existing.user)
                    .forEach((user: Models.IUser) => {
                        this.close({
                            name: this.$scope.vno.name,
                            existingUser: user,
                        });
                    });
            }
        }

        private validateUniques(): Promise<boolean> {
            $('[name="username"]').parsley().removeError('error-unique');
            $('[name="email"]').parsley().removeError('error-unique');
            // Parsley promise validation only works with Jquery promises
            return new Promise<boolean>((resolve: Function, reject: Function) => {
                this.userService.findByUsername(this.$scope.owner.user.username).then(() => {
                    reject(false);
                    $('[name="username"]').parsley().addError('error-unique', 
                                                              { message: 'This username already exists, please use a different one' });
                }).catch(() => {
                    this.userService.findByEmail(this.$scope.owner.user.email).then(() => {
                        $('[name="email"]').parsley().addError('error-unique', 
                                                               { message: 'This email already exists, please use a different one' });
                        reject(false);
                    }).catch(() => {
                        resolve(true);
                    });
                });
            });
        }
    }
}
